var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1),(_vm.$route.name !== 'main')?_c('Footer'):_vm._e(),_c('TopButton')],1)}
var staticRenderFns = []

export { render, staticRenderFns }